/* eslint-disable import/no-cycle */
/* eslint-disable import/no-named-as-default */
import { Action, CombinedState, combineReducers } from 'redux'
import lostCardSlice from 'redux/lostCard/lostCardSlice'
import maintenance from 'redux/maintenance/reducer'
import paymentMethod from 'redux/paymnetMethod/reducer'
import scheduleTransaction from 'redux/scheduleTransations/reducer'
import statement from 'redux/statement/statementSlice'
import videos from 'redux/videos/reducer'
import transactionsInfo from 'redux/transactionsInfo/transactionsInfoSlice'
import transactionStatement from 'redux/transactionStatement/reducer'
import viewPaymentTransactions from 'redux/paymentTransactions/reducer'
import recentActivity from 'redux/recentActivity/reducer'
import closeAccount from 'redux/closeAccount/reducer'
import autoPayHistory from 'redux/autoPayHistory/reducer'
import { LOGGED_OUT, UPDATE_REDUX_STATE } from 'redux/actionTypes'
import additionalBuyerCardSlice from 'redux/additionalBuyerCard/additionalBuyerCardSlice'
import appInfoSlice from 'redux/appInfo/appInfoSlice'
import authTokenSlice from 'redux/authToken/authTokenSlice'
import linkedAccountsSlice from 'redux/linkedAccounts/linkedAccountsSlice'
import resetPasswordSlice from 'redux/resetPassword/resetPasswordSlice'
import registrationSlice from 'redux/registration/registrationSlice'
import accountInfoSlice from 'redux/accountInfo/accountInfoSlice'
import invoiceNetTermsSlice from 'redux/invoiceNetTerms/invoiceNetTermsSlice'
import businessInfoSlice from 'redux/businessInfo/businessInfoSlice'
import buyerSlice from 'redux/buyer/buyerSlice'
import csrNotificationSlice from 'redux/csrAccountUpdate/csrNotificationSlice'
import invoiceSlice from 'redux/invoice/invoiceSlice'
import invoiceDownloadSlice from 'redux/invoiceDownload/invoiceDownloadSlice'
import invoiceUpdateSlice from 'redux/invoiceUpdate/invoiceUpdateSlice'
import poJobNamesSlice from 'redux/poJobNames/poJobNamesSlice'
import loginInfoSlice from 'redux/loginInfo/loginInfoSlice'
import accountSummarySlice from 'redux/accountSummary/accountSummarySlice'
import autoPayStatusSlice from 'redux/autoPayStatus/autoPayStatusSlice'
import eBillSlice from 'redux/ebill/eBillSlice'
import messageInfoSlice from 'redux/message/messageSlice'
import onlineUserSlice from 'redux/onlineUser/onlineUserSlice'
import paymentSlice from 'redux/payment/paymentSlice'
import viewPaymentSlice from 'redux/paymentHistory/paymentHistorySlice'
import editPaymentSlice from 'redux/updatePayment/updatePaymentSlice'
import paymentAccountSlice from 'redux/paymentAccount/paymentAccountSlice'
import recoverUserIdSlice from 'redux/recoverUserID/recoverUserIdSlice'
import demographicSlice from 'redux/demographic/demographicSlice'
import switchAccountSlice from 'redux/switchAccount/switchAccountSlice'
import dynamicContentSlice from './dynamicContent/dynamicContentSlice'
import configSlice from './config/configSlice'
import creditLimitIncreaseAutoSlice from './creditLimitIncreaseAuto/creditLimitIncreaseAutoSlice'

/*
 *Note: Import and combine reducers in alphabetical order to assist with how
 *      the order in which the Redux Dev Tools extension lists each reducer.
 */

const appReducer = combineReducers({
  accountSummary: accountSummarySlice,
  additionalBuyerCard: additionalBuyerCardSlice,
  appInfo: appInfoSlice,
  authTokenInfo: authTokenSlice,
  autoPayStatus: autoPayStatusSlice,
  autoPayHistory,
  businessInfo: businessInfoSlice,
  buyer: buyerSlice,
  cardInfo: accountInfoSlice,
  closeAccount,
  config: configSlice,
  creditLineIncreaseAuto: creditLimitIncreaseAutoSlice,
  csrAccountInfo: csrNotificationSlice,
  dynamicContent: dynamicContentSlice,
  eBill: eBillSlice,
  editPayment: editPaymentSlice,
  invoiceDownload: invoiceDownloadSlice,
  invoiceNetTerms: invoiceNetTermsSlice,
  invoiceSummary: invoiceSlice,
  linkedAccounts: linkedAccountsSlice,
  loginInfo: loginInfoSlice,
  lostCardInfo: lostCardSlice,
  maintenance,
  messageInfo: messageInfoSlice,
  onlineUser: onlineUserSlice,
  paidInvoiceSummary: invoiceUpdateSlice,
  payment: paymentSlice,
  paymentAccount: paymentAccountSlice,
  paymentMethod,
  poJobNames: poJobNamesSlice,
  recentActivity,
  recoverUserID: recoverUserIdSlice,
  registration: registrationSlice,
  resetPassword: resetPasswordSlice,
  scheduleTransaction,
  statement,
  switchAccount: switchAccountSlice,
  videos,
  transactionsInfo,
  transactionStatement,
  viewPayment: viewPaymentSlice,
  viewPaymentTransactions,
  welcomePanel: demographicSlice
})

export type OriginalRootState = ReturnType<typeof appReducer>

/*
 * Partial<T> makes props optional. This allows setting up partial store
 * objects during unit tests.
 */
export type RootState = Partial<OriginalRootState>

const initialState = JSON.parse(
  JSON.stringify(appReducer({} as OriginalRootState, {} as Action))
)

const rootReducer = (
  state: OriginalRootState,
  action: Action<string>
): CombinedState<OriginalRootState> => {
  let updatedState = state
  if (action.type === LOGGED_OUT) {
    const { config } = state || initialState
    updatedState = { ...initialState, config }
  }
  if (action.type === UPDATE_REDUX_STATE) {
    updatedState = JSON.parse(sessionStorage.getItem('reduxState'))
  }
  return appReducer(updatedState, action)
}

export default rootReducer
